import current from './current';
import update from './update';
import changeHandler from './changeHandler';

export default {
	namespaced: true,
	modules: {
    current, update, changeHandler
	}
}
